import React, {useEffect, useRef, useState} from 'react';
import { useSelector } from 'react-redux';
import Timer from "./Timer";
import { getDirection, pexios, toast } from "../../utils/functions";
import { isCellPhone, isNotValidName } from "../../utils/validator";
import { toast as toast2 } from 'react-toastify';
import {history} from "../../utils/variables";
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Modal from './Modal';

export default function LoginComponent({ type = '', getData, getStep = () => {}, submitAccidentType = false }) {

    const [login, setLogin] = useState({
        fname: '',
        lname: '',
        mobile: [0,9].concat(Array(9).fill('')),
        code: Array(4).fill(''),
    });
    const { t, i18n } = useTranslation();
    const [step, setStep] = useState(1);
    const [signupRequired, setSignupRequired] = useState(false);
    const [timer, setTimer] = useState(true);
    const [loader, setLoader] = useState(false);
    const [validationError,setValidationError] = useState({
        fname:'',
        lname: ''
    })
    const [codeBtnLoading,setCodeBtnLoading] = useState(true)
    const {user,insuranceCode} = useSelector(store => store);
    ////
    // const [test,setTest] = useState('')
    // const [isPesian,sertIsPersian] =useState(false);
    const [index,setIndex] = useState(step === 1 ? 2: 0);
    const [acceptance,setAcceptance] = useState(true)
    const [isRulesAccept,setIsRulesAccept] = useState(true)
    const ruleModal = useRef(null)

    useEffect(()=>{
        ///close rule acceptance alarm modal
        function handleClickOutside(event) {
            if (ruleModal.current && !ruleModal.current.contains(event.target)) {
                setIsRulesAccept(true);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    },[ruleModal])

    useEffect(()=>{
        //set mobile and code digit
        setIndex(step === 1 ? 2: 0)
    },[step])

    useEffect(()=>{
        setCodeBtnLoading(login.code[3] === '' || (signupRequired && (!login.fname || !login.lname || validationError.fname || validationError.lname)))
    },[login,validationError,signupRequired])
    // function isLangPersian(e) {
    //     // const index = 0;
    //     // const i =  e.key.charCodeAt(index);
    //     // if((i >= 1574 && i <= 1740) || i === 66){
    //     //     sertIsPersian(true)
    //     // }else{
    //     //     sertIsPersian(false)
    //     // }

    //      setTest(navigator.language)
    //     if(terms.includes(e.key) || e.keyCode === 'Backspace'){
    //         sertIsPersian(true)
    //     }else{
    //         sertIsPersian(false)
    //     }
    // }

    function changeText(value, name) {
        //
        // toast2.dismiss();
        // if(['fname','lname'].includes(name)){
        //     isPesian ?
        //         setLogin(prevState => ({
        //             ...prevState,
        //             [name]: value,
        //         }))
        //         :
        //         toast('لطفا فقط از حروف فارسی استفاده کنید!', 'error');
        // }else{
        // const englishRegex = /^(?=.*[a-z]|(?=.*[A-Z])|(?=.*[0-9])).*$/;
        if(isNotValidName(value)){
            setValidationError(prevState=>({
                ...prevState,
                [name] : `${name === 'fname' ? 'نام' :'نام خانوادگی'} را به صورت فارسی و بدون عدد وارد نمایید`
            }))
        }else {
            setValidationError(prevState=>({
                ...prevState,
                [name] : ''
            }))
        }
            setLogin(prevState => ({
                ...prevState,
                [name]: value,
            }));
        //}

    }

    function handleFocus(type){
        document.getElementById(`${type}-${index}`).focus();
    }
    function resetInputBox(type){
        if(type ==='code'){
            setLogin(prevState => ({
                ...prevState,
                code: Array(4).fill(''),
            }));
            setIndex(step === 1 ? 2: 0);
            document.getElementById(`code-0`).focus()
        }else{
            setLogin(prevState => ({
                ...prevState,
                mobile: [0,9].concat(Array(9).fill('')),
                code: Array(4).fill(''),
            }));
            setIndex(step === 1 ? 2: 0)
        }
    }

    function submitMobile() {
        if (submitAccidentType === 'user' && login.mobile.join('') === user.mobile) {
            // setLogin(prevState => ({
            //     ...prevState,
            //     mobile: [0,9].concat(Array(9).fill('')),
            //     code: Array(4).fill(''),
            // }));
            // setIndex(step === 1 ? 2: 0)
            resetInputBox('mobile')
            toast(t('Culprit and losses mobile had to be different'), 'error');
            return;
        }
        const isCellphoneValid = isCellPhone(login.mobile.join(''));
        if (!isCellphoneValid) {
            // setLogin(prevState => ({
            //     ...prevState,
            //     mobile: [0,9].concat(Array(9).fill('')),
            //     code: Array(4).fill(''),
            // }));
            // setIndex(step === 1 ? 2: 0)
            resetInputBox('mobile')
            toast(t('Mobile number is not valid'), 'error');
            return;
        }
        if(!acceptance){
            setIsRulesAccept(false);
            return;
        }
        setLoader(true);
        let payload
        if(submitAccidentType === 'user') {
            payload = {mobile: login.mobile.join('') ,loss_fullname :user.full_name,insuranceCode:insuranceCode}
        }else {
            payload = {mobile: login.mobile.join(''),insuranceCode:insuranceCode}
        }
        pexios('/api/login', 'post', payload)
            .then(res => {
                changeStep(2);
                setSignupRequired(!res.data.msg);
                setLoader(false);
            })
            .catch(err=>{
                if(err.response.data.status === 501){
                    resetInputBox('mobile')
                    toast(err.response.data.msg,'error')
                    setLoader(false);
                    return
                }
            })
        // :
        // pexios('/api/login', 'post', {mobile: login.mobile.join('')})
        //     .then(res => {
        //         changeStep(2);
        //         setSignupRequired(!res.data.msg);
        //         setLoader(false);
        //     })
        //     .catch(err=>{
        //         if(err.response.data.status === 501){
        //             resetInputBox('mobile')
        //             toast(err.response.data.msg,'error')
        //             setLoader(false);
        //             return
        //         }
        //     })
    }
    function submitCode() {
        setLoader(true);
        toast2.dismiss();
        const loginData = {
            ...login,
            mobile: login.mobile.join(''),
            code: login.code.join(''),
        }
        if(loginData.code.length >0){
            if(!signupRequired || (login.fname.length>1 && login.lname.length>1)) {
                if((isNotValidName(login.fname)||isNotValidName(login.lname))){
                    toast('لطفا نام و نام خانوادگی خود را به صورت فارسی و بدون عدد وارد نمایید.', 'error');
                    setLoader(false);
                }else{
                    pexios('/api/check_code', 'post', loginData)
                        .then(res => {
                            setLoader(false);
                            getData(res.data.data);
                        })
                        .catch(err => {
                            if (err.response.data.msg === 'IncorrectCode') {
                                // setLogin(prevState => ({
                                //     ...prevState,
                                //     code: Array(4).fill(''),
                                // }));
                                // setIndex(step === 1 ? 2 : 0)
                                // document.getElementById(`code-0`).focus();
                                resetInputBox('code');
                                setLoader(false);
                                toast(t('Code is wrong'), 'error');
                            }
                        });
                }
            }else{
                // if(!acceptance){
                //     setIsRulesAccept(false);
                //     setLoader(false);
                //     return;
                // }
                setLoader(false);
                toast(t('Enter your first name and last name'), 'error');
            }
        }else{
            setLoader(false);
            toast(t('Please enter code'), 'error');
        }

    }
    function resendCode() {
        setLoader(true);
        pexios('/api/resend_code', 'post', { mobile: login.mobile.join('') ,insuranceCode:insuranceCode})
            .then(() => {
                setTimer(true);
                setLoader(false);
                // setLogin(prevState => ({
                //     ...prevState,
                //     code: Array(4).fill(''),
                // }));
                // setIndex(step === 1 ? 2: 0)
                //document.getElementById(`code-0`).focus();
                resetInputBox('code');
            });
    }
    function changeStep(step) {
        setStep(step);
        getStep(step);
    }


    function deleteNumberChecking (event ,type){
        const total = type === "mobile" ? 11:4;
         if(event.key === 'Backspace'){
                if(index === total-1 && document.getElementById(`${type}-${index}`).value !== ''){
                    const copyLogin = type === "mobile" ? login.mobile:login.code;
                    copyLogin[index] = ''
                    setLogin(prevState => ({
                        ...prevState,
                        [type]:copyLogin
                    }))
                }else if(type === "mobile" ? index !== 2 :index !== 0){
                    const copyLogin = type === "mobile" ? login.mobile:login.code;
                    copyLogin[index-1] = ''
                    setLogin(prevState => ({
                        ...prevState,
                        [type]:copyLogin
                    }))
                    setIndex(index-1)
                    document.getElementById(`${type}-${index-1}`).focus();
                }
            }
    }
    function handleChangeNumber (event,type){
        const total = type === "mobile" ? 11:4;
        if(index === total-1 &&(type === "mobile" ? !login.mobile[index]: !login.code[index])){ ///if it's last index and empty
            const copyLogin = type === "mobile" ? login.mobile:login.code;
            copyLogin[index] = event.target.value
            setLogin(prevState => ({
                ...prevState,
                [type]:copyLogin
            }))
            ///if code and fname and lname exist
            if(type === "code" && copyLogin[total-1]!== ''&& (!signupRequired || (login.fname.length>1 && login.lname.length>1))){
                submitCode();
            }
        }else if(index < total-1){
            const copyLogin = type === "mobile" ? login.mobile:login.code;
            copyLogin[index] = event.target.value
            setLogin(prevState => ({
                ...prevState,
                [type]:copyLogin
            }))
            setIndex(index+1)
            document.getElementById(`${type}-${index+1}`).focus();
        }
    }

    return (
        step === 1 ?
            <div className="login-input" data-dir={getDirection(i18n.language)}>
                <Modal visible={!isRulesAccept}>
                    <div className='modal-content' ref={ruleModal}>
                        <p className='m30'>
                            جهت استفاده از خدمات اپلیکیشن <span style={{color:'#f6945a',fontWeight: '600'}}>بالن</span> لازم است قوانین و مقررات را بپذیرید
                        </p>
                        <div className='d-flex justify-center ml20 mr20'>
                            <button className='btn btn-block btn-white-purple btn-circle m10' onClick={()=>history.push('/rules')}>مطالعه قوانین</button>
                            <button className='btn btn-block btn-orange btn-circle m10' onClick={()=>{setAcceptance(true);setIsRulesAccept(true)}}>پذیرش قوانین</button>
                        </div>
                    </div>
                </Modal>
                <div className="login-welcome">
                    {
                        submitAccidentType ?
                        <>
                        {submitAccidentType === 'user' ?
                        <>
                        <p className="welcome-msg mx10"> {user.full_name} {t('Dear')}</p>
                        <div className='m10 rtl text-justify'>
                        
                        {t('Submit the request as')}{ <span style={{fontWeight:700}}> {t('Losses')}</span>} {t('Accident message')}
                        
                        {/* {t('Enter culprit mobile number')} */}
                        لطفا شماره<span style={{color:'#d95202'}}> تلفن همراه مقصر حادثه </span> را جهت ارسال کد اعتبارسنجی وارد نمایید.
                         </div>
                         </>
                         :
                         <div className='m10 text-right'>
                            لطفا شماره تلفن همراه مقصر را وارد نمایید
                         </div>
                        }
                        </>
                        :
                        <>
                        <div className="welcome-msg">{t('Login greeting')}</div>
                        <div>{t('Please enter your mobile number')}</div>
                        </>
                    }
                </div>
                <div className='group-input-box-phone'>
                    <i className='fas fa-mobile-alt'/>
                    <>
                        {login.mobile.map((val,i)=>(
                            <input
                                type='number'
                                className='input-box-phone'
                                id={`mobile-${i}`}
                                min="0"
                                max="9"
                                pattern="[0-9]*"
                                maxLength="1"
                                inputMode="numeric"
                                onChange={(e)=>handleChangeNumber(e,'mobile')}
                                onKeyDown={(e)=>deleteNumberChecking(e,'mobile')}
                                value={login.mobile[i]}
                                key={`mobile-${i}`}
                                onClick={()=>handleFocus('mobile')}
                                autoFocus ={i===2}
                                readOnly={i === 0 || i === 1}

                            />
                        ))}
                        </>
                </div>
                {!submitAccidentType &&
                <div className='d-flex mb20 mt10 mr20' style={{direction: "rtl"}}>
                    <label className='custom-checkbox' style={{marginTop:'3px'}}>
                        <input type='checkbox' checked={acceptance} onChange={(e) => setAcceptance(e.target.checked)}/>
                        <span className='checkmark'/>
                    </label>
                    <p className='mr25 rules-accept-text'><Link to='/rules' style={{color: 'rgb(0 153 201)'}}>{t('Rules and condition')}</Link> {t('NotifModal i read and accept')}</p>
                </div>
                }
                <div className='d-flex flex-row-reverse justify-center'>
                <button
                    className={`btn w-50 ml10 mr10 btn-circle ${(!loader && login.mobile[10] !== '') ? 'btn-white-purple btn-bold' :'btn-disable'} mt20 phone-next-step`}
                    disabled={loader || login.mobile[10] === ''}
                    onClick={submitMobile}
                >
                    {
                        loader ?
                            <i className='fas fa-spinner fa-spin'/>
                            : t('Next step')
                    }
                </button>
                {
                    submitAccidentType &&
                    <button
                        className='btn w-50 btn-circle btn-orange mt20 phone-next-step ml10 mr10'
                        onClick={()=> history.push("/")}
                    > {t('Reject')}</button>
                }
                </div>
            </div> :
            <div>
                {/* <Modal visible={!isRulesAccept}>
                    <div className='modal-content' ref={ruleModal}>
                        <p className='m30'>
                            جهت استفاده از خدمات اپلیکیشن <span style={{color:'#f6945a',fontWeight: '600'}}>بالن</span> لازم است قوانین و مقررات را بپذیرید
                        </p>
                        <div className='d-flex justify-center ml20 mr20'>
                            <button className='btn btn-block btn-white-purple btn-circle m10' onClick={()=>history.push('/rules')}>مطالعه قوانین</button>
                            <button className='btn btn-block btn-orange btn-circle m10' onClick={()=>{setAcceptance(true);setIsRulesAccept(true)}}>پذیرش قوانین</button>
                        </div>
                    </div>
                </Modal> */}
                {submitAccidentType &&
                <p className='mb20 mt10 login-label'>
                    کد پبامک شده به شماره  <span style={{color:'#d95202'}}>تلفن همراه مقصر</span> حادثه به شماره <span style={{fontWeight:600}}>" {login.mobile.join('')} "</span> را وارد نمایید.
                    {/* {t('Enter the code that send to culprit')} {<b>{t('Culprit')}</b>} {t('Accident number',{mobile: login.mobile.join('')})} */}
                </p>
            }
                
                {!submitAccidentType &&<div className="login-label" style={{fontWeight:'500'}}>{t('Deliverd code')}</div>}
                
                <div className='group-input-box-code'>
                    <>
                    {login.code.map((val,i)=>(
                        <input
                            type="number"
                            className='input-box-code'
                            id={`code-${i}`}
                            min="0"
                            max="9"
                            pattern="[0-9]*"
                            maxLength="1"
                            inputMode="numeric"
                            onChange={(e)=>handleChangeNumber(e,'code')}
                            onKeyDown={(e)=>deleteNumberChecking(e,'code')}
                            value={login.code[i]}
                            key={`code-${i}`}
                            onClick={()=>handleFocus('code')}
                            autoFocus ={i===0}
                        />
                    ))}
                    </>
                </div>
                {
                    signupRequired &&
                    <div className='ml40 mr40'>
                        <div className='input-parent withIcon rtl mt10'>
                            <input
                                value={login.fname}
                                type='text'
                                placeholder={`${t('First name')} ${type}`}
                                onChange={e => changeText(e.target.value, 'fname')}
                            />
                            <i className='fas fa-user'/>
                        </div>
                        {validationError.fname && <small className='feild-validation'>{validationError.fname}</small>}
                        <div className='input-parent withIcon rtl mt10'>
                            <input
                                value={login.lname}
                                type='text'
                                placeholder={`${t('Last name')} ${type}`}
                                onChange={e => changeText(e.target.value, 'lname')}
                            />
                            <i className='fas fa-user'/>
                        </div>
                        {validationError.lname && <small className='feild-validation'>{validationError.lname}</small>}
                        {/* <div className='d-flex mt20' style={{direction: "rtl"}}>
                            <label className='custom-checkbox' style={{marginTop:'3px'}}>
                                <input type='checkbox' checked={acceptance} onChange={(e) => setAcceptance(e.target.checked)}/>
                                <span className='checkmark'/>
                            </label>
                            <p className='mr25 rules-accept-text'><Link to='/rules' style={{color: 'rgb(0 153 201)'}}>{t('Rules and condition')}</Link> {t('NotifModal i read and accept')}</p>
                        </div> */}
                    </div>
                }
                <div className='d-flex justify-center'>
                <button
                    className={`
                        btn w-50 btn-circle ${codeBtnLoading ?'btn-disable':'btn-white-purple'}
                        btn-bold mt20`}
                    disabled={loader || codeBtnLoading}
                    onClick={submitCode}
                    id="submit-code"
                >
                    {
                        loader ?
                            <i className='fas fa-spinner fa-spin'/> :
                            t('Confirm')
                    }
                </button>
                </div>
                <div className='mt10'>
                    {
                        timer ?
                            <Timer seconds={120} onFinish={() => setTimer(false)} /> :
                            <div className='d-flex'>
                                <a className='btn btn-block btn-circle btn-green mr5' href='tel:09964080473'>
                                    {t('Contact with company')}
                                </a>
                                <button
                                    className='btn btn-block btn-circle btn-yellow ml5'
                                    disabled={loader}
                                    onClick={resendCode}
                                >
                                    {
                                        loader ?
                                            <i className='fas fa-spinner fa-spin'/> :
                                            t('Send code again')
                                    }
                                </button>
                            </div>
                    }
                </div>
            </div>
    );

}
